<div class="container" *ngIf="finishedLoading">
    <div class="row">
        <div class="col-sm-12">
            <h4>Exportierte Dateien
            </h4>
        </div>
    </div>

    <div class="row">
        <div class="col-sm-12">
            <div class="example-container mat-elevation-z2">
                <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z2">
                    <ng-container matColumnDef="number">
                        <th mat-header-cell *matHeaderCellDef>
                            #
                        </th>
                        <td mat-cell *matCellDef="let card; let i = index;" class="mat-column">
                            {{i+1}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="type">
                        <th mat-header-cell *matHeaderCellDef>
                            Typ
                        </th>
                        <td mat-cell *matCellDef="let card" class="mat-column">
                            {{card.processType | translateState}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef>
                            Dateiname
                        </th>
                        <td mat-cell *matCellDef="let card" class="mat-column ">
                            {{card.name | truncate : 100 : false}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="size">
                        <th mat-header-cell *matHeaderCellDef>
                            Größe
                        </th>
                        <td mat-cell *matCellDef="let card" class="mat-column">
                            {{card.size}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="date">
                        <th mat-header-cell *matHeaderCellDef>
                            Vom
                        </th>
                        <td mat-cell *matCellDef="let card" class="mat-column">
                            {{card.lastModified | date : 'hh:mm:ss dd.MM.YYYY'}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="menu">
                        <th mat-header-cell *matHeaderCellDef>
                            Aktion
                        </th>
                        <td mat-cell *matCellDef="let card" class="mat-column">
                            <button mat-icon-button style="margin: 0 auto !important;" [matMenuTriggerFor]="menu"
                                color="accent">
                                <mat-icon>more_vert</mat-icon>
                            </button>
                            <mat-menu #menu="matMenu">
                                <button mat-menu-item (click)="saveFile(card)"> Lokal speichern</button>
                            </mat-menu>


                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;let i = index"></tr>
                </table>
                <span *ngIf="dataSource?.data.length === 0" class="emptyTableState  mat-elevation-z2">Keine passenden
                    Einträge
                    gefunden...</span>
            </div>
        </div>
    </div>
</div>

<div class="container" *ngIf="!finishedLoading">
    <div class="row">
        <div class="col-sm-12 padding">
            <div class="loadingOverlay">
                <mat-spinner></mat-spinner>
            </div>
        </div>
    </div>
</div>